import React, { useState } from "react";
import { Form, Row, Col, Button, Alert } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import logo_dark from "../assets/img/logo.png";
import { login } from "../common/api"; // Your actual login API function
import { Sentry } from "react-activity";
import { ShowToast, handleChange } from "../common/function";

export default function Login() {
  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [apiError, setApiError] = useState("");
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
    const newErrors = {};

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(email)) {
      newErrors.email = "Enter a valid email address";
    }

    if (!password) {
      newErrors.password = "Password is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setApiError("");

    if (!validateForm()) return;

    try {
      setLoading(true);
      const response = await login({ email, password }); // API call
      console.log(response);
      setLoading(false);

      if (response.success === true) {
        localStorage.setItem("token", response.body.token);
        localStorage.setItem("userDetail", JSON.stringify(response.body));
        localStorage.setItem("IsLogin", true);
        ShowToast(1, "login successfully");

        navigate("/dashboard");
      } else {
        ShowToast(0, response.message || "Login failed");
      }
    } catch (err) {
      setLoading(false);
      setApiError("Something went wrong. Please try again.");
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col lg={6} className="loginform">
          <div className="loginmain_div maxwidth500 mx-auto">
            <div className="headlogin_div mb-4">
              <img className="loginlogo_img" src={logo_dark} alt="" />
              <h2>
                Welcome To <span>ZenFlow</span>
              </h2>
            </div>

            <Form onSubmit={handleSubmit}>  
              {apiError && (
                <Alert variant="danger" className="mb-3">
                  {apiError}
                </Alert>
              )}

              <Form.Group className="mb-4 form-group">
                <Form.Label>Email Addresss</Form.Label>
                <Form.Control
                  type="email"
                  placeholder="Enter email address"
                  value={email}
                  onChange={(e) => {
                    const value = e.target.value;
                    setEmail(value);

                    if (errors.email) {
                      if (value && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
                        setErrors((prev) => ({ ...prev, email: "" }));
                      }
                    }
                  }}
                  isInvalid={!!errors.email}
                />

                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4 form-group">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="password"
                  placeholder="Enter password"
                  value={password}
                  onChange={(e) => {
                    const value = e.target.value;
                    setPassword(value);

                    if (errors.password) {
                      if (value) {
                        setErrors((prev) => ({ ...prev, password: "" }));
                      }
                    }
                  }}
                  isInvalid={!!errors.password}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.password}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-4 form-group forgotpassword text-end">
                <Link to="/forgot-password">Forgot Password?</Link>
              </Form.Group>

              <Button
                type="submit"
                className="btn btn-primary w-100"
                disabled={loading}
              >
                {loading ? "Logging in..." : "Login"}
              </Button>
            </Form>
          </div>
        </Col>

        <Col lg={6} className="loginmb_none">
          <div className="loginlogo_div">
            <Link>
              <img src={logo_dark} alt="" />
            </Link>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );
}
